import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from 'lodash/get';
import { FADE, SLIDE, ON_REVEAL } from '../../animation.constants';
import FadeReveal from '../Reveal/variants/FadeReveal/FadeReveal';
import SlideReveal from '../Reveal/variants/SlideReveal/SlideReveal';
export function getAnimationComponent(on, animationName) {
  var _ON_REVEAL;
  var ANIMATION_BY_TYPE = _defineProperty({}, ON_REVEAL, (_ON_REVEAL = {}, _defineProperty(_ON_REVEAL, SLIDE, SlideReveal), _defineProperty(_ON_REVEAL, FADE, FadeReveal), _ON_REVEAL));
  return _get(ANIMATION_BY_TYPE, "".concat(on, ".").concat(animationName), null);
}